module.exports = __webpack_public_path__ + "img/2f7a724.jpg";